import styled, { DefaultTheme } from 'styled-components';

const mapColors = ({ theme }: { theme: DefaultTheme }) =>
  theme.type === 'light'
    ? {
        $bg: theme.colors.white[1000],
      }
    : {
        $bg: theme.colors.black[800],
      };

export const Container = styled.div.attrs(mapColors)`
  border-radius: ${(p) => p.theme.borderRadius};
  background-color: ${(p) => p.$bg};
  box-shadow: ${(p) => p.theme.type === 'light' && p.theme.defaultShadow};
  width: 100%;
  max-width: 500px;
  padding: 1rem 0;

  max-width: 800px;
  min-width: unset;
  border-radius: 20px;
  padding: 20px 20px;
  margin: 20px 0;

  @media (max-width: 800px) {
    max-width: 720px;
    margin: 0 auto;
  }

  & .MuiButton-containedPrimary {
    height: 58px;
    padding: 0 40px;
    font-weight: bold;
  }
`;

const mapColors2 = ({ theme }: { theme: DefaultTheme }) =>
  theme.type === 'light'
    ? { $bg: theme.sellerTheme.primary.value }
    : { $bg: theme.colors.black[900] };

export const ModalContainerWrapper = styled.div.attrs(mapColors2)`
  background-color: ${(p) => p.$bg};
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
`;
